import React from 'react';
import { crawlingService } from '../../services/crawlingService';

const CrawlingStatusBadge = ({ 
  status, 
  size = 'sm', 
  showIcon = true, 
  showText = true,
  className = '' 
}) => {
  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-xs',
    sm: 'px-2 py-1 text-xs',
    md: 'px-2.5 py-1.5 text-sm',
    lg: 'px-3 py-2 text-base'
  };

  const iconSizes = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const baseClasses = `inline-flex items-center font-medium rounded-full ${sizeClasses[size]} ${className}`;
  const colorClasses = crawlingService.getStatusColor(status);
  const icon = crawlingService.getStatusIcon(status);

  const statusDisplayMap = {
    pending: 'Pending',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
    retrying: 'Retrying',
    cancelled: 'Cancelled'
  };

  const statusText = statusDisplayMap[status] || status;

  return (
    <span className={`${baseClasses} ${colorClasses}`}>
      {showIcon && (
        <span className={`${iconSizes[size]} ${showText ? 'mr-1' : ''}`}>
          {icon}
        </span>
      )}
      {showText && statusText}
    </span>
  );
};

export default CrawlingStatusBadge;